// Port of underscore.string 3.3.5 `slugify`, kept byte-for-byte compatible so existing
// CSS class names (card types, operator names) don't change.
const DIACRITICS_FROM = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž';
const DIACRITICS_TO = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz';

const FROM = DIACRITICS_FROM + DIACRITICS_FROM.toUpperCase() + 'ß';
const TO = [...(DIACRITICS_TO + DIACRITICS_TO.toUpperCase()).split(''), 'ss'];

const makeString = (value) => (value == null ? '' : '' + value);

const cleanDiacritics = (str) =>
    makeString(str).replace(/.{1}/g, (c) => {
        const index = FROM.indexOf(c);
        return index === -1 ? c : TO[index];
    });

const dasherize = (str) =>
    str
        .trim()
        .replace(/([A-Z])/g, '-$1')
        .replace(/[-_\s]+/g, '-')
        .toLowerCase();

export default function slugify(str) {
    const dashed = dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase());
    return dashed.replace(/^[-]+|[-]+$/g, '');
}
